const translations = {
  "upload.title": "Upload",
  "upload.selectHeader": "Select Header",
  "upload.mapColumns": "Map Columns",
  "upload.expectedColumn": "Expected Column",
  "upload.required": "Required",
  "upload.dropFile": "Drop your file here",
  "upload.or": "or",
  "upload.browse": "Browse files",
  "upload.downloadTemplate": "Download Template",
  "upload.fileTypes": "Only CSV, XLS, and XLSX files can be uploaded",
  "upload.selectHeaderRow": "Select Header Row",
  "upload.selectHeaderRowHelp": "Select the row which contains the column headers",
  "upload.excelSheetWarning": "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.",
  "common.cancel": "Cancel",
  "common.continue": "Continue",
  "mapping.fileColumn": "Your File Column",
  "mapping.sampleData": "Your Sample Data",
  "mapping.destinationColumn": "Destination Column",
  "mapping.include": "Include",
  "mapping.submit": "Submit",
  "common.loading": "Loading...",
  "mapping.requiredColumns": "Please include all required columns",
  "common.back": "Back",
  "common.selectOne": "- Select one -",
  "common.empty": "- empty -",
  "success.import": "Import Successful",
  "success.upload": "Upload Successful",
  "common.done": "Done",
  "success.uploadAnother": "Upload another file",
};

export default translations; 